import Image from "next/image";
import { ArrowUpRight } from "lucide-react";

import type { PortfolioEntry } from "@/data/portfolio";

export function PortfolioCard({ item }: { item: PortfolioEntry }) {
  return (
    <article
      className="
        flex h-full flex-col overflow-hidden rounded-[32px]
        border border-white/15 bg-white/95 text-foreground
        shadow-[0_35px_90px_-70px_rgba(7,25,82,0.95)] transition-transform duration-300
        hover:-translate-y-1.5
      "
    >
      {/* Tall screenshot */}
      <div className="relative overflow-hidden p-5 pb-4">
        <div className="relative overflow-hidden rounded-[24px] border border-black/5 bg-white shadow-[0_20px_65px_-45px_rgba(7,25,82,1)]">
          <Image
            src={item.image}
            alt={`Tangkapan layar ${item.title}`}
            width={900}
            height={1350}
            loading="lazy"
            sizes="(min-width: 1024px) 320px, 70vw"
            className="h-auto w-full object-cover"
          />
        </div>
      </div>

      <div className="px-6 pb-4">
        <h3 className="text-center text-xl font-semibold text-foreground">
          {item.title}
        </h3>
      </div>

      {/* Buttons */}
      <div
        className="
          grid gap-3 border-t border-black/5 px-6 py-5 text-sm font-medium text-foreground/80
          sm:grid-cols-2
        "
      >
        <a
          href={item.image}
          target="_blank"
          rel="noopener noreferrer"
          className="
            flex items-center justify-center rounded-full border border-black/10
            bg-white py-2.5 text-center transition hover:border-black/20 hover:bg-black/5
          "
        >
          Detail
        </a>
        <a
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 rounded-full bg-primary py-2.5 text-center text-white shadow-[0_15px_35px_-20px_rgba(8,131,149,1)] transition hover:bg-primary/90"
        >
          Demo
          <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
        </a>
      </div>
    </article>
  );
}
